import React from 'react'

const Profile = () => {
  return (
    <>
      Profile
    </>
  )
}

export default Profile
